import { useQuery } from '@tanstack/react-query';
import { groupBy, sortBy } from 'lodash';
import { DateService, getParameters } from 'Services';
import { MAX_32_BIT_INT, RQ_PARAMETERS, snakeCaseToTitleCase } from 'Utils';

type Props = {
    queryParams?: GetParametersQueryParams;
};

const groupParametersByType = (parameters: Parameter[]) => {
    return groupBy(parameters, (param) => param.parameterType) as ParameterTypeHashmap;
};

const useGetParameters = ({ queryParams }: Props) => {
    return useQuery(
        [RQ_PARAMETERS, queryParams],
        () =>
            getParameters({
                perPage: MAX_32_BIT_INT,
                ...queryParams
            }),
        {
            select: (parameters) => {
                const sortedParameters = sortBy(parameters, (param) => param.message?.toLowerCase());

                const original: ParameterGETResponse[] = [];
                let parameterTypeHashmap: ParameterTypeHashmap = {};
                const fieldNameHashmap: ParameterFieldNameHashmap = {};
                const idHashmap: ParameterFieldIdHashmap = {};

                sortedParameters.forEach((param) => {
                    const formatted = {
                        modifiedAt: DateService.getDateTime(param.modifiedAt) ?? param.modifiedAt,
                        source: param.source[0].toUpperCase() + param.source.slice(1),
                        parameterType: snakeCaseToTitleCase(param.parameterType),
                        tppType: param.tppType && param.tppType[0].toUpperCase() + param.tppType.slice(1),
                        linkedItemsCount: param.linkedRules.length + param.childParameterIds.length
                    };

                    original.push({
                        ...param,
                        _formatted: formatted
                    });
                    idHashmap[param.id] = { ...param, _formatted: formatted };
                    fieldNameHashmap[param.fieldName] = { ...param, _formatted: formatted };
                });

                parameterTypeHashmap = groupParametersByType(sortedParameters);

                return { original, parameterTypeHashmap, idHashmap, fieldNameHashmap };
            }
        }
    );
};

export default useGetParameters;
